import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Maximize2, Minimize2 } from "lucide-react";

// Bottom-sheet checkout chrome that matches the client-portal invoice popup.
export function PaymentSheet({ subtitle, onClose, children, flush = false }) {
  const [expanded, setExpanded] = useState(false);
  // Lock the background page so only the popup scrolls while it's open.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);
  return createPortal((
    <div onClick={onClose} className="lx-keep-dark fixed inset-0 z-[140] bg-black/85 flex items-end justify-center" data-testid="payment-sheet">
      <div onClick={(e) => e.stopPropagation()} className={`w-full rounded-t-2xl overflow-hidden bg-[#12151a] border border-white/10 shadow-2xl flex flex-col transition-all ${expanded ? "sm:max-w-6xl h-[96vh]" : "sm:max-w-4xl h-[80vh]"}`}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-white/10 shrink-0">
          <h3 className="font-display font-semibold text-[15px] text-white">Secure checkout</h3>
          <div className="flex items-center gap-3">
            <button onClick={() => setExpanded((e) => !e)} data-testid="payment-sheet-expand" title={expanded ? "Shrink" : "Expand"}>{expanded ? <Minimize2 size={17} className="text-white/50 hover:text-white" /> : <Maximize2 size={17} className="text-white/50 hover:text-white" />}</button>
            <button onClick={onClose} data-testid="payment-close"><X size={18} className="text-white/50 hover:text-white" /></button>
          </div>
        </div>
        <div className={flush ? "flex-1 overflow-y-auto overflow-x-hidden no-scrollbar" : "p-4 bg-white flex-1 overflow-y-auto overflow-x-hidden no-scrollbar"}>
          {!flush && subtitle && <p className="text-[13.5px] font-semibold text-neutral-800 mb-3">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  ), document.body);
}
